import { Snackbar, Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ErrorAlertSnackbar = ({ open, onClose, message, vertical, horizontal }) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={2000}
            onClose={onClose}
            anchorOrigin={{ vertical, horizontal }}
        >
            <Alert
                icon={<CheckCircleIcon sx={{ color: "success.contrastText" }} />}
                onClose={onClose}
                severity="error"
                sx={{
                    bgcolor: "error.main",
                    color: "success.contrastText",
                    boxShadow: 3,
                    borderRadius: '0.25rem',
                    p: '0.375rem 1rem',
                    "& .MuiAlert-icon": { color: "success.contrastText" },
                }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default ErrorAlertSnackbar;